package com.milta.core.localization.translations.nl

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Optimalisatiequotum bereikt",
    exhaustedCreateRouteMessage = "Weer beschikbaar op {date}. U kunt de ronde zonder optimalisatie aanmaken: de ingevoerde volgorde blijft behouden.",
    exhaustedCreateBatchMessage = "Terug naar {limit} optimalisaties op {date}. De batch kan zonder optimalisatie worden aangemaakt: de ingevoerde volgorde blijft behouden.",
    quotaReachedResetOn = "Optimalisatiequotum bereikt — reset op {date}",
    routeCreatedInEnteredOrder = "Ronde aangemaakt in de ingevoerde volgorde.",
    routeWillBeCreatedInEnteredOrder = "De ronde wordt aangemaakt in de ingevoerde volgorde.",
    batchCreatedInEnteredOrder = "De batch is zonder optimalisatie aangemaakt, in de ingevoerde volgorde.",
    sendWithoutOptimization = "Verzenden zonder optimalisatie",
    batchNotOptimizedTitle = "Batch aangemaakt zonder optimalisatie",
    batchNotOptimizedMessage = "Optimalisatiequotum bereikt. De huidige volgorde van de stops blijft behouden.",
    batchNotOptimizedMobileMessage = "Batch aangemaakt zonder optimalisatie: optimalisatiequotum bereikt. Ingevoerde volgorde behouden, stops gelijk verdeeld.",
    reoptimizeAction = "Opnieuw optimaliseren",
    reoptimizeUnavailableWeb = "Opnieuw optimaliseren niet beschikbaar: quotum bereikt, weer beschikbaar op {date}. De huidige volgorde blijft behouden en verzenden blijft mogelijk.",
    reoptimizeUnavailableMobile = "Opnieuw optimaliseren niet beschikbaar tot {date} (quotum bereikt). Verzenden blijft mogelijk.",
    stopAddedAtEndTitle = "Stop toegevoegd aan het einde van de ronde",
    stopAddedAtEndMessage = "Optimalisatiequotum bereikt — reset op {date}. De volgorde van de andere stops verandert niet.",
    reoptimizeExhaustedHint = "Optimalisatiequotum bereikt, weer beschikbaar op {date}",
    myOptimizationsTitle = "Mijn optimalisaties",
    remainingForPeriod = "Resterend voor deze periode",
    remainingSuffix = "resterend",
    resetLabel = "Reset",
    resetAtRenewal = "Bij verlenging van het abonnement",
    driverExplanation = "Wordt gereset bij de verlenging van uw abonnement. Chauffeur van een Onderneming: uw teller volgt het abonnement van de Onderneming, met de proeflimiet zolang die in proef is.",
    enterpriseExplanation = "Wordt gereset bij de verlenging van uw abonnement. Deze teller geldt alleen voor uw eigen optimalisaties; elke chauffeur heeft er een.",
    webCounterNotice = "Deze teller geldt alleen voor optimalisaties gestart door dit account. Elke chauffeur heeft zijn eigen teller, zichtbaar in zijn app.",
    historyTitle = "Geschiedenis",
    columnDate = "Datum",
    columnAction = "Actie",
    columnTarget = "Betrokken ronde",
    columnOutcome = "Resultaat",
    actionOptimizeRoute = "Een ronde optimaliseren",
    actionCreateRouteBatch = "Een batch aanmaken",
    actionReoptimizeRouteBatch = "Een batch opnieuw optimaliseren",
    actionReoptimizeOnStopAdded = "Opnieuw optimaliseren bij een nieuwe stop",
    actionReoptimizeInPlace = "Ter plaatse opnieuw optimaliseren",
    actionCreateOwnRoute = "Mijn ronde aanmaken",
    outcomeCounted = "Geteld",
    outcomeRefunded = "Teruggegeven",
    outcomeRefundedLong = "Teruggegeven — fout RoutaR",
    refundedNotCounted = "fout RoutaR, niet geteld",
    targetRoute = "Ronde van {date}",
    targetBatch = "Batch van {date}",
    historyLoadingMore = "Volgende regels laden…",
    historyEnd = "Einde van de geschiedenis — {count} regels",
    historyEmpty = "Geen optimalisaties in deze periode.",
    historyLoadError = "Kan de geschiedenis niet laden.",
    retryAction = "Opnieuw proberen",
    loading = "Laden…",
    errorNoConnection = "Kan de server niet bereiken — controleer uw verbinding.",
    errorGeneric = "Er is een fout opgetreden. Probeer het later opnieuw.",
    tabOptimizations = "RoutaR-optimalisaties",
    tabAiTokens = "AI-tokens",
    comingSoon = "Binnenkort",
    limitsDescription = "Aantal toegestane RoutaR-optimalisaties per account en per abonnementsperiode, volgens het type account en de status van het abonnement. De teller van elk account wordt gereset bij de verlenging van zijn abonnement.",
    columnTrial = "Proef",
    columnPaid = "Betaald",
    rowEnterprise = "Ondernemingsaccount",
    rowDriver = "Chauffeur",
    fieldRequired = "Verplicht veld.",
    fieldMustBePositive = "Moet groter zijn dan 0.",
    limitsFootnote = "Waarden in optimalisaties per periode. Een chauffeur van een Onderneming krijgt de limiet \"Chauffeur\", proef zolang zijn Onderneming in proef is, anders betaald.",
    limitsSaved = "Limieten opgeslagen. Onderneming: {enterpriseTrial} proef · {enterprisePaid} betaald. Chauffeur: {driverTrial} proef · {driverPaid} betaald.",
    limitsRejected = "Waarden geweigerd: elke limiet moet groter zijn dan 0.",
    saveAction = "Opslaan",
    detailsAction = "Details",
    accountDetailsTitle = "Gebruikersdetails",
    sectionIdentity = "Identiteit",
    accountTypeLabel = "Type account",
    kindEnterpriseOwner = "Ondernemingsaccount",
    kindEnterpriseDriver = "Chauffeur van een Onderneming",
    kindIndependentDriver = "Zelfstandige chauffeur",
    withoutOrganisation = "Zonder organisatie",
    subscriptionLabel = "Abonnement",
    viaOrganisation = "Via organisatie",
    subscriptionTrial = "Proef",
    subscriptionPaid = "Betaald",
    appliedLimitLabel = "Toegepaste limiet",
    limitKindEnterprise = "Limiet Ondernemingsaccount",
    limitKindDriver = "Limiet Chauffeur",
    enterpriseInTrialSuffix = "(de Onderneming is in proef)",
    resetSourceOwn = "Verlenging van het abonnement",
    resetSourceEnterprise = "Verlenging van {enterprise}",
    exhaustedBadge = "Quotum opgebruikt",
    manuallyAdjustedBadge = "Handmatig vervangen",
    replaceLabel = "Resterend aantal vervangen",
    replaceAction = "Vervangen",
    replaceHelp = "Alleen voor de huidige periode. Bij de reset start het account opnieuw vanaf de globale limiet.",
    replaceHelpEnterpriseDriver = "Wijzigt alleen de teller van {name}. Die van de Onderneming en van de andere chauffeurs verandert niet.",
    replaceInvalid = "Voer een getal groter dan of gelijk aan 0 in.",
    replaceRejected = "Waarde geweigerd door de server.",
    replaceMaximum = "Maximaal 100.000.",
    replacedBanner = "Resterend aantal vervangen: {from} → {to}. Voor de huidige periode. Op {date} terug naar de globale limiet ({limit}).",
    adminHistoryTitle = "Geschiedenis van de optimalisaties",
    accountNotFound = "Account niet gevonden.",
)
